import React from "react";
import Layout from "layouts";
import QueueComponent from "./QueueComponent";

export default function Queue() {
  return (
    <Layout breadCrumb={[{ label: "Queue", to: "#" }]}>
      <QueueComponent />
    </Layout>
  );
}
